import { NotificationUseCaseEnum, UserAppLangEnum } from '../../..';

export class PushNotificationRequestDto {
  notificationUseCase: NotificationUseCaseEnum;
  appLang: UserAppLangEnum;
  danceEventId: string;
  danceManagerName: string;
  danceEventName: string;
}
